import React, { useState, useEffect } from "react";
import "../../Assets/Styles/Style.css";
import CustomCard from "../../utils/Card/CustomCard";
import { toast } from "react-toastify";
import PropTypes from "prop-types";
import useApi from "../useApi";

function CardSummary({ cards }) {
  const [summaryData, setSummaryData] = useState({});
  const { Get } = useApi();
  useEffect(() => {
    fetchBackofficeSummary();
  }, []);
  const fetchBackofficeSummary = async () => {
    try {
      const data = await Get("getBackofficeSummary");
      setSummaryData(data);
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Error fetching data from server. Contact humbingo.");
    } finally {
    }
  };
  const getColumnSize = () => {
    const numberOfCards = cards.length;
    switch (numberOfCards) {
      case 1:
        return 12;
      case 2:
        return 6;
      case 3:
        return 4;
      case 4:
        return 3;
      default:
        return 3;
    }
  };
  const formatValue = (value, dataKey) => {
    if (dataKey === "total_penalty" || dataKey === "total_invested") {
      const formattedValue = Number(value).toLocaleString("en-IN");
      return `₹ ${formattedValue}`;
    }
    return value;
  };
  return (
    <div className="summary-grid">
      {cards.map((card, index) => (
        <div key={index} className="summary-item">
          <CustomCard
            title={card.title}
            value={formatValue(summaryData[card.dataKey], card.dataKey)}
            image={card.image}
          />
        </div>
      ))}
    </div>
  );
}
CardSummary.propTypes = {
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      dataKey: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
    })
  ).isRequired,
};
export default CardSummary;
